var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import moment from "moment-timezone";
import WeekView from "@/Pages/Calendar/WeekView";
import BookingLayout from "@/Pages/Booking/BookingLayout";
import Breadcrumb from "@/Jetstream/Breadcrumb";
export default function Calendar(_a) {
    var team = _a.team, calendar = _a.calendar, startDate = _a.startDate, booking_slots = _a.booking_slots, appointments = _a.appointments;
    // parse the startDate string
    var $startDate = new Date(startDate);
    var $endDate = moment($startDate).add(7, 'days').toDate();
    booking_slots.map(function (rule) {
        rule.items.map(function (slot) {
            slot.$startDate = new Date(slot.start_date);
            slot.$endDate = new Date(slot.end_date);
            slot.$color = slot.appointment ? 'indigo' : 'orange'; // hover:bg-orange-200 bg-orange-200 bg-orange-100 bg-orange-50 border-orange-200 border-orange-600 // hover:bg-green-200 bg-green-200 bg-green-100 bg-green-50 border-green-200 border-green-600
        });
    });
    return (_jsx(BookingLayout, __assign({ team: team, title: "Calendar", pageTitle: calendar.name, breadCrumb: _jsx(Breadcrumb, { team: team, calendar: calendar }) }, { children: _jsx(WeekView, { editingRule: null, team: team, calendar: calendar, startDate: $startDate, endDate: $endDate, bookingSlots: booking_slots, appointments: appointments }) })));
}
